import { dmpParams, dmpMutations } from './../store/dmp'
import { reportDmp } from './../request/dmp'

/**
 * 对vue-router进行路由注入
 * @param {Object} router 
 */
export default function regRouter(router) {
    router.beforeRouteUpdate ((to, from, next) => {
        if(to.name == from.name) next()
        dmpParams.list_visited_path.push(to.path)
        // DMP访问上报
        if (!from.name) {
            dmpParams.time_visit_begin = new Date()
            // 自动上报visit
            if (dmpParams.autoVisit) reportDmp({ action: 'visit' })

            // 自动上报leave
            if (dmpParams.autoLeave) {
                window.addEventListener('unload', ()=>{
                    reportDmp({ action: 'leave' })
                }, true)
            }
        }
    
        // 清除DMP曝光上报队列
        dmpParams.list_dmp_multi_pop = []
    
        // DMP停留时长上报
        if (dmpParams.autoTimeline && dmpParams.time_pv_begin) {
            let staytime = (new Date()) - dmpParams.time_pv_begin,
            params = {
                action: 'timeline',
                staytime,
                hash: from.path
            }
        
            // 详情页添加title和id
            if (dmpMutations.isCahce('timeline')) {
                params = dmpMutations.getCache( params, 'timeline' )
                dmpMutations.clearCache('timeline')
            }
        
            dmpParams.time_pv_begin = null
            setTimeout(() => {
                reportDmp(params)
            },600)
        }

        // 移除批量事件绑定
        dmpMutations.removeEvents()

        next()
    })
    
    // 全局后置守卫
    router.beforeRouteLeave((to, from) => {
        // DMP每页pv上报
        if (dmpParams.autoPv && to.name === from.name) {
            dmpParams.time_pv_begin = new Date()
            let params = {
              action: 'pv',
              hash: to.path
            }
            // 详情页添加title和id
            if (dmpMutations.isCahce('pv')) {
                params = dmpMutations.getCache( params, 'pv' )
                dmpMutations.clearCache('pv')
                dmpMutations.setCache(params, 'timeline')
            }
        
            setTimeout(() => {
                reportDmp(params)
            },400)
        }
    })
}